"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const n={slideUp:{duration:"0.6s",delay:"0ms",timingFunction:"ease-in-out",keyFrame:"\n      0% {\n        transform: translateY(150px);\n        opacity: 0;\n      }\n      20% {\n        opacity: 1;\n      }\n      100% {\n        transform: translateY(0);\n      }\n    "},fadeInUp:{duration:"0.4s",delay:"0ms",timingFunction:"ease-in-out",keyFrame:"\n      0% {\n        transform: translateY(50px);\n        opacity: 0;\n      }\n      100% {\n        transform: translateY(0);\n        opacity: 1;\n      }\n    "}};exports.default=n;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/tabs/cjs/util/animationConfig.js
// module id = 1265
// module chunks = 0